import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetChatTextMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ChatTextMessage = (param)=>{
    let { content, messageId } = param;
    const { ChatTextMessageTID } = useMemo(()=>GetChatTextMessageTID(messageId), [
        messageId
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        testId: ChatTextMessageTID.Root(),
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: ChatTextMessageTID.Text(),
            showWhiteSpaces: true,
            applyMarkdownBold: true,
            children: content.text
        })
    });
};
